export default function formatUtils(): any {
  function formatCurrency(value: any, anzahlDezimalstellen = 2): string {
    if (!value || isNaN(value) || value < 0) {
      return "0,00 €";
    }
    return Number(value).toLocaleString("de-DE", {
      style: "currency",
      currency: "EUR",
      maximumFractionDigits: anzahlDezimalstellen,
      minimumFractionDigits: anzahlDezimalstellen,
    });
  }

  function getZahlungsweiseAlsText(schluessel: any): string {
    switch (schluessel.toString()) {
      case "1":
        return "jährlich";
      case "2":
        return "halbjährlich";
      case "4":
        return "vierteljährlich";
      case "12":
        return "monatlich";
      default:
        return "";
    }
  }

  const formatIban = (value: string): string => {
    let val = value.replace(/ /, "");

    const val_chars = val.split("");
    val = "";

    let count = 1;
    for (const index in val_chars) {
      if (count <= 2) {
        val_chars[index] = val_chars[index].toUpperCase();
        if (val_chars[index].search(/^[A-Z]+$/) == -1) {
          break;
        }
      } else {
        if (val_chars[index].search(/^\d+$/) == -1) {
          continue;
        }
      }

      val += val_chars[index];

      if (count % 4 == 0) {
        val += " ";
      }
      count++;
    }

    return val.trim();
  };

  const anredeText = (anredeSchluessel: string): string => {
    switch (anredeSchluessel) {
      case "Z001":
        return "";
      case "0001":
        return "Frau";
      case "0002":
        return "Herr";
      case "0003":
        return "Firma";
      case "ETG":
        return "Eigen&shy;tümer&shy;gemein&shy;schaft";
      case "WEG":
        return "Wohnungs&shy;eigen&shy;tümer&shy;gemeinschaft";
      default:
        return "";
    }
  };

  return {
    formatCurrency,
    getZahlungsweiseAlsText,
    formatIban,
    anredeText,
  };
}
